// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"ResetChatRadar_resetButton__25_C3","label":"ResetChatRadar_label__34LX5","icon":"ResetChatRadar_icon__2eO2s","divider":"ResetChatRadar_divider__1ywQl"};